module.exports = __webpack_public_path__ + "static/media/DashedLine.fbd4eaf8.svg";